<mat-card fxLayoutGap class="p-3">
  <div class="fw-semibold fs-4">{{licenseId?'Modifica Licenza':'Nuova Licenza'}}</div>
  <form [formGroup]="formGroup" class="d-flex flex-column gap-3 pb-3" style="overflow-y: auto; max-height: 68vh;">
    <div class="w-100">
      <app-dea-label class="mb-2" [label]="'Sedi:'"></app-dea-label>
      <div formArrayName="headquarters" class="d-flex flex-row gap-4">
        <div *ngFor="let headquarter of headquartersListing; let i = index">
          <mat-checkbox [formControlName]="i" color="primary" [labelPosition]="'after'">
            {{ headquarter }}
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="w-100">
      <app-dea-label class="mb-2" [label]="'Titolo:'"></app-dea-label>
      <input formControlName="title" type="text" class="form-control dea-form-input" />
    </div>
    <div class="d-flex flex-row w-100 gap-3 dea-border dea-radius p-2" style="border-width: 3px;">
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Chiave PRIVATA:'"></app-dea-label>
        <input formControlName="private_key" type="text" class="form-control dea-form-input" />
        <div class="mt-1 fs-055r fw-lighter opacity-65">
          NON salvare password personali o di amministrazione in questo campo
        </div>
      </div>
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Chiave CONDIVISA:'"></app-dea-label>
        <input formControlName="key" type="text" class="form-control dea-form-input" />
      </div>
    </div>
    <div class="d-flex flex-row w-100 gap-3">
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Dashboard Link:'"></app-dea-label>
        <input formControlName="dashboard_link" type="url" class="form-control dea-form-input" />
      </div>
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Link (Condiviso):'"></app-dea-label>
        <input formControlName="link" type="url" class="form-control dea-form-input" />
      </div>
    </div>
    <div class="d-flex flex-row w-100 gap-3">
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Inizio:'"></app-dea-label>
        <input formControlName="start" type="date" class="form-control dea-form-input" />
      </div>
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Fine:'"></app-dea-label>
        <input formControlName="end" type="date" class="form-control dea-form-input" />
      </div>
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Numero:'"></app-dea-label>
        <input formControlName="available" type="number" class="form-control dea-form-input" />
      </div>
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Abilitata:'"></app-dea-label>
        <mat-slide-toggle formControlName="enabled" class="ms-3 mt-2" color="primary"></mat-slide-toggle>
      </div>
    </div>
    <div class="w-100">
      <app-dea-label class="mb-2" [label]="'Istruzioni (Condivise):'"></app-dea-label>
      <textarea formControlName="instructions" class="form-control dea-form-input" rows="2"
        style="max-height: 80px !important;"></textarea>
    </div>
    <div class="d-flex flex-column gap-2">
      <div class="d-flex justify-content-between align-items-center">
        <app-dea-label [label]="'Configurazioni per assegnazione asincrona automatica:'"></app-dea-label>
        <app-dea-fast-action-btn class="ms-auto" (click)="addAutoAssignment()">Aggiungi</app-dea-fast-action-btn>
      </div>
      <ng-container formArrayName="auto_assignments">
        <div *ngFor="let group of autoAssignments.controls; let i = index" [formGroupName]="i"
          class="d-flex flex-column gap-2 p-3 border rounded">
          <div>
            <div class="d-flex justify-content-between">
              <app-dea-label [label]="'Sedi:'"></app-dea-label>
              <app-dea-fast-action-btn class="ms-auto" (click)="removeAutoAssignment(i)">
                Rimuovi
              </app-dea-fast-action-btn>
            </div>
            <div formArrayName="headquarters" class="d-flex flex-row gap-4">
              <label *ngFor="let headquarter of headquartersListing; let index = index">
                <mat-checkbox [formControlName]="index" color="primary" [labelPosition]="'after'">
                  {{ headquarter }}
                </mat-checkbox>
              </label>
            </div>
          </div>
          <div>
            <app-dea-label [label]="'Tipo di utenti:'"></app-dea-label>
            <div formArrayName="user_types" class="d-flex flex-row gap-4">
              <label *ngFor="let type of userTypesListing; let index = index">
                <mat-checkbox [formControlName]="index" color="primary" [labelPosition]="'after'">
                  {{ convertUserType(type) }}
                </mat-checkbox>
              </label>
            </div>
          </div>
          <div>
            <app-dea-label [label]="'Classi:'"></app-dea-label>
            <div formArrayName="years" class="d-flex flex-row gap-4">
              <label *ngFor="let year of [1,2,3,4,5]; let index = index">
                <mat-checkbox [formControlName]="index" color="primary" [labelPosition]="'after'">
                  {{ year }}
                </mat-checkbox>
              </label>
            </div>
          </div>
          <div>
            <app-dea-label [label]="'Sezioni:'"></app-dea-label>
            <div formArrayName="sections" class="d-flex flex-row gap-4">
              <label *ngFor="let section of ['A','B','C']; let index = index">
                <mat-checkbox [formControlName]="index" color="primary" [labelPosition]="'after'">
                  {{ section }}
                </mat-checkbox>
              </label>
            </div>
          </div>
          <div>
            <app-dea-label [label]="'Dipartimenti:'"></app-dea-label>
            <div formArrayName="departments" class="d-flex flex-row flex-wrap gap-2">
              <label *ngFor="let department of departmentsListing; let index = index">
                <mat-checkbox [formControlName]="index" color="primary" [labelPosition]="'after'">
                  {{ department }}
                </mat-checkbox>
              </label>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </form>
  <div class="m-0 p-0 mt-3 gap-2" mat-dialog-actions align="end">
    <button class="px-5 py-1" mat-stroked-button (click)="onDismiss()">Annulla</button>
    <button *ngIf="!isPosting" class="px-5 py-1" mat-flat-button color="primary" (click)="onConfirm()">
      Salva
    </button>
    <button *ngIf="isPosting" class="px-5 py-1" mat-flat-button disabled>
      <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon> Caricamento
    </button>
  </div>
</mat-card>